import { render, staticRenderFns } from "./ICChanPinXinXi_phone.vue?vue&type=template&id=5a65d77f&scoped=true"
import script from "./ICChanPinXinXi_phone.vue?vue&type=script&lang=js"
export * from "./ICChanPinXinXi_phone.vue?vue&type=script&lang=js"
import style1 from "./ICChanPinXinXi_phone.vue?vue&type=style&index=1&id=5a65d77f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65d77f",
  null
  
)

export default component.exports